export default __webpack_public_path__ + "static/media/weightlossregime@3x.25c46c02.jpg";